import { Button, Heading, Typography } from '@altify/components';
import { useContent } from '@altify/utils';
import { DialogOrBottomSheet } from 'components/DialogOrBottomSheet/DialogOrBottomSheet';
import { exploreVerificationContent } from '../verification.content';
import { useNavigate } from '@tanstack/react-router';
import { VerifyIdentity } from '../assets/icons/verification/VerifyIdentity';
import { SecureData } from '../assets/icons/verification/SecureData';
import { UnderReview } from '../assets/icons/verification/UnderReview';
import { CompletedIcon } from '../assets/icons/verification/CompletedIcon';
import { VerifyIcon } from '../assets/icons/verification/VerifyIcon';
import closeIcon from '../assets/close.svg'

export const InvestmentJourneyModal = ({
  isModalOpen,
  onClose,
  investmentJourneyStatus
}: {
  isModalOpen: boolean;
  onClose?: () => void;
  investmentJourneyStatus: string | null;
}) => {
  
  const localizedContent = useContent(exploreVerificationContent);
  const navigate = useNavigate();

  return (
    <div>
      <DialogOrBottomSheet isOpen={isModalOpen} onClose={onClose}>
        <div className="flex flex-col items-center gap-4 px-2 py-4 lg:px-12 pb-8 md:pb-4">
          {/* VERIFICATION NOT STARTED */}
          {investmentJourneyStatus === 'UNVERIFIED' ?
            <>
              <Heading level={2} className='leading-8 text-center font-normal'>
                {localizedContent.verifyIdentity.heading}
              </Heading>
              <button type="button" onClick={() => onClose?.()} className="hidden sm:block absolute right-2 top-2">
                <img src={closeIcon} alt="exit" />
              </button>
              <div className="flex flex-col px-4 md:px-8 lg:px-12">
                <Typography size='medium' variant='body' weight='regular' className='text-grey-light text-center mt-2'>{localizedContent.verifyIdentity.subHeading}</Typography>
              </div>
              
              {/* USER STEPS */}
              <div className="flex flex-col px-6 md:px-10 lg:px-16 mt-2 justify-start w-full">
                {localizedContent.verifyIdentity.steps?.map((step) => (
                  <div className="flex flex-row w-full gap-4 justify-start my-4 md:my-1" key={step.id}>
                    <div className="flex flex-col">
                      {step.id === 'create' ? 
                        <CompletedIcon />
                      : 
                        <VerifyIcon />
                      }
                    </div>
                    <div className="flex flex-col">
                      <Typography size='medium' variant='body' weight='regular' className='text-white text-left'>{step.heading}</Typography>
                      <Typography size='small' variant='body' weight='regular' className='text-[#636AA1] text-left'>{step.subHeading}</Typography>
                    </div>
                  </div>
                ))}
              </div>

              {/* DATA STORED SECURELY */}
              <div className="flex flex-row gap-1 justify-center mt-4 mb-6">
                <div className='mt-0.5'>
                  <SecureData />
                </div>
                <Typography size='medium' variant='body' weight='regular' className='text-grey-light'>{localizedContent.securedData}</Typography>
              </div>
              <div className="flex flex-col gap-3 w-full">
                <Button
                  text={localizedContent.continue}
                  onPress={() => navigate({ to: `/verification` })}
                />
              </div>
            </>
          :
          investmentJourneyStatus === 'VERIFICATION_IN_PROGRESS' ?
            <>
              <Heading level={2} className='leading-8 text-center font-normal'>{localizedContent.verifyIdentity.heading}</Heading>
              <button type="button" onClick={() => onClose?.()} className="hidden sm:block absolute right-2 top-2">
                <img src={closeIcon} alt="exit" />
              </button>
              <div className="flex flex-col px-4 md:px-8 lg:px-12">
                <Typography size='medium' variant='body' weight='regular' className='text-grey-light text-center mt-2'>{localizedContent.verifyIdentity.subHeading}</Typography>
              </div>
              
              {/* USER STEPS */}
              <div className="flex flex-col px-6 md:px-10 lg:px-16 mt-2 justify-start w-full">
                {localizedContent.verifyIdentity.steps?.map((step) => (
                  <div className="flex flex-row w-full gap-4 justify-start my-4 md:my-1" key={step.id}>
                    <div className="flex flex-col">
                      {step.id === 'create' ? 
                        <CompletedIcon />
                      : 
                        <VerifyIcon />
                      }
                    </div>
                    <div className="flex flex-col">
                      <Typography size='medium' variant='body' weight='regular' className='text-white text-left'>{step.heading}</Typography>
                      {step.id === 'create' ? 
                        <Typography size='small' variant='body' weight='regular' className='text-[#636AA1] text-left'>{step.subHeading}</Typography>
                      :
                        <Typography size='small' variant='body' weight='regular' className='text-[#636AA1] text-left'>{step.continueHeading}</Typography>
                      }
                    </div>
                  </div>
                ))}
              </div>

              {/* DATA STORED SECURELY */}
              <div className="flex flex-row gap-1 justify-center mt-4 mb-6">
                <div className='mt-0.5'>
                  <SecureData />
                </div>
                <Typography size='medium' variant='body' weight='regular' className='text-grey-light'>{localizedContent.securedData}</Typography>
              </div>
              <div className="flex flex-col gap-3 w-full">
                <Button
                  text={localizedContent.continue}
                  onPress={() => navigate({ to: `/verification` })}
                />
              </div>
            </>
          :
          investmentJourneyStatus === 'VERIFICATION_UNDER_REVIEW' ? 
            <>
              {/* VERIFICATION UNDER REVIEW */}
              <div className="flex flex-col justify-center mb-2">
                <UnderReview />
              </div>

              <Heading level={2} className='leading-8 text-center font-normal'>{localizedContent.underReview.heading}</Heading>
              <button type="button" onClick={() => onClose?.()} className="hidden sm:block absolute right-2 top-2">
                <img src={closeIcon} alt="exit" />
              </button>

              <div className="flex flex-col px-4 md:px-8 lg:px-12">
                <Typography size='medium' variant='body' weight='regular' className='text-grey-light text-center mt-2'>{localizedContent.underReview.subHeading}</Typography>
              </div>
              {/* DATA STORED SECURELY */}
              <div className="flex flex-row gap-1 justify-center mt-4 mb-6">
                <div className='mt-0.5'>
                  <SecureData />
                </div>
                <Typography size='medium' variant='body' weight='regular' className='text-grey-light'>{localizedContent.securedData}</Typography>
              </div>

              <div className="flex flex-col gap-3 w-full px-8 lg:px-4">
                <Button
                  text={localizedContent.exploreInvestments}
                  onPress={onClose}
                />
              </div>
            </>
          : investmentJourneyStatus === 'MAKE_DEPOSIT' ? 
            <>
              {/* VERIFICATION COMPLETED AND NO DEPOSIT */}
              <div className="flex flex-col justify-center mb-2">
                <VerifyIdentity />
              </div>
              <Heading level={2} className='leading-8 text-center font-normal'>{localizedContent.verificationCompleted.heading}</Heading>
              <button type="button" onClick={() => onClose?.()} className="hidden sm:block absolute right-2 top-2">
                <img src={closeIcon} alt="exit" />
              </button>
              <div className="flex flex-col px-4 md:px-8 lg:px-12">
                <Typography size='medium' variant='body' weight='regular' className='text-grey-light text-center mt-2'>{localizedContent.verificationCompleted.subHeading}</Typography>
              </div>
              {/* DATA STORED SECURELY */}
              <div className="flex flex-row gap-1 justify-center mt-4 mb-6">
                <div className='mt-0.5'>
                  <SecureData />
                </div>
                <Typography size='medium' variant='body' weight='regular' className='text-grey-light'>{localizedContent.securedData}</Typography>
              </div>

              <div className="flex flex-col gap-3 w-full px-8 lg:px-4">
                <Button
                  text={localizedContent.bankDeposit}
                  onPress={() => navigate({ to: `/funds/deposit/fiat` })}
                />
                <Button
                  text={localizedContent.cryptoDeposit}
                  onPress={() => navigate({ to: `/funds/deposit/crypto` })}
                />
              </div>
            </>
          : null}

        </div>
      </DialogOrBottomSheet>
    </div>
  );
};
